import React from 'react'
import {colors} from "../../utils/styles"

// Return HTML to be compatible with tooltip usage in TotalChargeAndInvoiceRenderer
export function getPaymentOutstandingMessageHtml(amount) {
  return "<span>There is an incomplete payment in PayCargo for the amount of " + amount + ".</span>"
}

const HintMessage = ({data}) => {

  const amount = data.reduce((result, ea) => result || ea.lastPaymentAmount, null)
  return (
      <div
          style={{
            fontSize: '14px',
            color: colors.red,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            paddingLeft: 20,
            paddingTop: 10,
            fontWeight: 600,
          }}
      >
        <img src="images/icon-unpaid.svg" style={{paddingRight: 5}} alt="unpaid"/>
        <div dangerouslySetInnerHTML={{__html: getPaymentOutstandingMessageHtml(amount, false)}}/>
      </div>
  )
}

export default HintMessage